import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useEffect, useState } from "react";
import { doLogout } from "../Utilities";
import Spinner from "./Spinner";

export default function WaitingAlert() {
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);

  useEffect(() => {
    const timer = setTimeout(
      () => doLogout(setAlertMessage, setShowAlert, setSpinnerVisibility),
      10000
    );
  }, []);

  return (
    <div className="p-5">
      <Spinner visibility={spinnerVisibility} />
      <Alert
        severity="error"
        style={{
          display: showAlert ? "flex" : "none",
        }}
      >
        {alertMessage}
      </Alert>
      <Accordion sx={{ backgroundColor: "#FFF8ED" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="font-skyBold text-gray-800 mb-5"
        >
          <ErrorOutlineIcon sx={{ color: "orange" }} />{" "}
          <span className="ml-3"> Account Pending Activation</span>
        </AccordionSummary>
        <AccordionDetails>
          <p className="mb-2">Thank you for signing up!</p>
          <p className="mb-2">
            Your request has been successfully submitted, and your account is
            pending activation.
          </p>
          <p className="mb-2">
            In the meantime, please check your email for updates on the status
            of your approval.
          </p>
          <p className="mb-2">
            Once you receive the acceptance email, please{" "}
            <button
              onClick={() =>
                doLogout(setAlertMessage, setShowAlert, setSpinnerVisibility)
              }
              className="text-blue-500 hover:underline cursor-pointer font-bold"
            >
              logout and log back in
            </button>{" "}
            to access your account.
          </p>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
